import { render } from "./Menu.vue?vue&type=template&id=9280527e"
import script from "./Menu.vue?vue&type=script&lang=js"
export * from "./Menu.vue?vue&type=script&lang=js"
script.render = render

export default script